import { ObjectUtils } from './object.utils';

export abstract class TranslateUtils {
    private static en = {
        UPLOAD_FILE: 'Upload File',
        FILE_FIELD: 'File',
        FORM_VALIDATION: {
            MISSING: 'Missing',
            REQUIRED: 'is required',
            FILE_TOO_LARGE: 'The maximum file size should not be more than 28 MB.',
            CAPTCHA: 'Captcha',
            EMAIL: {
                INCORRECT: 'Please enter a valid email address'
            },
            FIRSTNAME: {
                INCORRECT: 'Please enter a valid first name'
            },
            LASTNAME: {
                INCORRECT: 'Please enter a valid last name'
            },
            COMPANYNAME: {
                INCORRECT: 'Please enter a valid company name'
            },
            BIRTHDAY: {
                INCORRECT: 'Please enter a valid birthday'
            },
            SUBSCRIBE: {
                REQUIRED: 'Please select the option'
            },
            URL: {
                INCORRECT: 'Please enter a valid URL (starting with http:// or https://)'
            },
            NUMBER: {
                OVER_MAX_VALUE: 'Value must be no more than',
                OVER_MIN_VALUE: 'Value must be at least',
                INVALID_NUMBER: 'Please enter a valid number'
            },
            TEL: {
                INVALID_CHARACTERS: 'Please enter a valid phone number',
                MIN_DIGITS_COUNT: 'The phone field value is 10 digits minimum',
                MAX_LENGTH: 'The phone field value is 20 symbols maximum'
            },
            DATE: {
                INCOMPLETE_DATE: 'Date entered is incomplete'
            },
            CHECKBOX: {
                MIN_OPTIONS: 'Please select at least one option',
                OVER_MIN_VALUE: 'The minimum number of options is',
                OVER_MAX_VALUE: 'The maximum number of options is',
            },
            RADIO: {
                REQUIRED: 'Please select an option'
            },
            FILE: {
                REQUIRED: 'Please select a file'
            },
            PASSWORD: {
                MISMATCH: 'Passwords do not match'
            },
            GDPR_POLICY_CONSENT: 'agreement with the Privacy Policy'
        },
        EMAIL_FIELD: {
            LABEL: 'Email',
            PLACEHOLDER: 'Enter your email',
        },
        FIRSTNAME_FIELD: {
            LABEL: 'First name',
            PLACEHOLDER: 'Enter your first name',
        },
        LASTNAME_FIELD: {
            LABEL: 'Last name',
            PLACEHOLDER: 'Enter your last name',
        },
        COMPANYNAME_FIELD: {
            LABEL: 'Company name',
            PLACEHOLDER: 'Enter your company name',
        },
        BIRTHDAY_FIELD: {
            LABEL: 'Birthday',
            FORMAT: 'MM/dd/yyyy',
            PLACEHOLDER: 'MM/DD/YYYY'
        },
        SIGNATURE_FIELD: {
            LABEL: 'Signature',
            PLACEHOLDER: 'Sign here',
            CLEAR_BUTTON: 'Clear'
        },
        SUBSCRIBE_FIELD: {
            LABEL: 'Yes, subscribe me to the newsletter.',
        },
        ADDRESS_1_FIELD: {
            LABEL: 'Street Address',
            PLACEHOLDER: 'House number and street name'
        },
        ADDRESS_2_FIELD: {
            LABEL: 'Street Address Line 2'
        },
        CITY_FIELD: {
            LABEL: 'City'
        },
        STATE_FIELD: {
            LABEL: 'State / Province / Region'
        },
        POSTAL_FIELD: {
            LABEL: 'Zip / Postal Code',
        },
        COUNTRY_FIELD: {
            LABEL: 'Country',
        },
        URL_FIELD: {
            LABEL: 'Link',
            DESCRIPTION: 'Enter your link',
            PLACEHOLDER: 'Enter link',
        },
        RADIO_FIELD: {
            LABEL: 'Radio',
            OPTION: 'Option'
        },
        NUMBER_FIELD: {
            LABEL: 'Number',
            PLACEHOLDER: 'Enter a number',
        },
        TEL_FIELD: {
            LABEL: 'Mobile phone',
            PLACEHOLDER: 'Enter your phone',
        },
        TEXT_FIELD: {
            LABEL: 'Short answer',
            PLACEHOLDER: 'Write here...'
        },
        PASSWORD_FIELD: {
            LABEL: 'Password',
            PLACEHOLDER: 'Enter password...',
            CONFIRMATION_LABEL: 'Confirm Password',
            CONFIRMATION_PLACEHOLDER: 'Confirm your password...',
            SHOW_PASSWORD: 'Show password',
            HIDE_PASSWORD: 'Hide password',
            STRENGTH: {
                MIN_LENGTH: 'Use at least 10 characters',
                MIXED_CASE: 'Include uppercase and lowercase english letters',
                HAS_NUMBER: 'Include at least one number'
            }
        },
        TEXTAREA_FIELD: {
            LABEL: 'Long answer',
            PLACEHOLDER: 'Write here...'
        },
        CHECKBOX_FIELD: {
            LABEL: 'Checkbox',
            CHOICE: 'Choice'
        },
        TEXT_WIDGET: {
            THANKFUL_PAGE_HEADER: 'Thank you for your submission!',
            THANKFUL_PAGE_TEXT: 'Your submission has been received.'
        },
        SUBMIT_WIDGET: {
            LABEL: 'Submit',
            PREVIOUS_LABEL: 'previous',
            NEXT_LABEL: 'next'
        },
        SIGN_IN_WIDGET: {
            TEXT: 'Log In'
        },
        SIGN_UP_WIDGET: {
            TEXT: 'Sign Up'
        },
        FORGOT_PASSWORD_WIDGET: {
            TEXT: 'Forgot your password?'
        },
        DATE_FIELD: {
            LABEL: 'Date',
            FORMAT: 'MM/dd/yyyy'
        },
        DROPDOWN_FIELD: {
            LABEL: 'Dropdown',
            OPTION: 'Option',
            PLACEHOLDER: 'Select from a list',
        },
        HIDDEN_FIELD: {
            LABEL: 'Hidden variable field',
            SAVE_TO: 'Save to',
            TYPE_DATE: 'Date & Time',
            TYPE_TEXT: 'Text',
            TYPE_NUMBER: 'Number',
            TYPE_EMAIL: 'Email',
            VALUE_EQ: 'Value Equals',
            SUBMISSION_DATE: 'Date & Time Submission'
        },
        ERRORS: {
            CAPTCHA_UNPREPARED: 'Captcha is unprepared',
            VALIDATION_ERROR: 'Validation error',
            INTERNAL_SERVER_ERROR: 'Something went wrong...',
            TRU_CAPTCHA_INVALID_CHALLENGE_ID: 'Invalid TruCAPTCHA ChallengeId',
            TRU_CAPTCHA_MISSED_RESPONSE: 'TruCAPTCHA response is missed',
            TRU_CAPTCHA_INVALID_RESPONSE: 'Invalid TruCAPTCHA response',
            GOOGLE_RECAPTCHA_NOT_CONFIGURED: 'Google reCAPTCHA is not configured',
            GOOGLE_RECAPTCHA_MISSED_RESPONSE: 'Google reCAPTCHA response is missed',
            GOOGLE_RECAPTCHA_INVALID_RESPONSE: 'Invalid Google reCAPTCHA response',
            UNHANDLED_ERROR: 'Something went wrong...',
            FORM_NOT_AVAILABLE: 'Form is not available'
        },
        GDPR: {
            I_ACCEPT: 'I agree to the ',
            AND: ' and the ',
            PRIVACY_POLICY: 'Privacy Policy',
            AGREEMENT_DEFAULT_VOLUME: 'I agree to the Privacy Policy',
            BY_CLICKING_THE: 'By clicking the "',
            YOU_GIVE_US_PERMISSION: '" button, you give us permission to send you marketing and other email communications. You may opt-out at any time.'
        },
        COUNTRY: {
            AF: 'Afghanistan',
            AL: 'Albania',
            DZ: 'Algeria',
            AD: 'Andorra',
            AO: 'Angola',
            AI: 'Anguilla',
            AG: 'Antigua and Barbuda',
            AR: 'Argentina',
            AM: 'Armenia',
            AU: 'Australia',
            AT: 'Austria',
            AZ: 'Azerbaijan',
            BS: 'Bahamas',
            BH: 'Bahrain',
            BD: 'Bangladesh',
            BB: 'Barbados',
            BY: 'Belarus',
            BE: 'Belgium',
            BZ: 'Belize',
            BJ: 'Benin',
            BM: 'Bermuda',
            BT: 'Bhutan',
            BO: 'Bolivia',
            BA: 'Bosnia and Herzegovina',
            BW: 'Botswana',
            BR: 'Brazil',
            IO: 'British Indian Ocean Territory',
            VG: 'British Virgin Islands',
            BN: 'Brunei',
            BG: 'Bulgaria',
            BF: 'Burkina Faso',
            BI: 'Burundi',
            CV: 'Cabo Verde',
            KH: 'Cambodia',
            CM: 'Cameroon',
            CA: 'Canada',
            KY: 'Cayman Islands',
            CF: 'Central African Republic',
            TD: 'Chad',
            CL: 'Chile',
            CO: 'Colombia',
            KM: 'Comoros',
            CK: 'Cook Islands',
            CR: 'Costa Rica',
            HR: 'Croatia',
            CU: 'Cuba',
            CY: 'Cyprus',
            CZ: 'Czech Republic',
            CD: 'Democratic Republic of the Congo',
            DK: 'Denmark',
            DM: 'Dominica',
            DO: 'Dominican Republic',
            EC: 'Ecuador',
            EG: 'Egypt',
            SV: 'El Salvador',
            GQ: 'Equatorial Guinea',
            ER: 'Eritrea',
            EE: 'Estonia',
            ET: 'Ethiopia',
            FK: 'Falkland Islands',
            FO: 'Faroe Islands',
            FM: 'Federated States of Micronesia',
            FJ: 'Fiji',
            FI: 'Finland',
            FR: 'France',
            GA: 'Gabon',
            GM: 'Gambia',
            GE: 'Georgia',
            DE: 'Germany',
            GH: 'Ghana',
            GR: 'Greece',
            GL: 'Greenland',
            GD: 'Grenada',
            GT: 'Guatemala',
            GN: 'Guinea',
            GW: 'Guinea-Bissau',
            GY: 'Guyana',
            HT: 'Haiti',
            HN: 'Honduras',
            HU: 'Hungary',
            IS: 'Iceland',
            IN: 'India',
            ID: 'Indonesia',
            IR: 'Iran',
            IQ: 'Iraq',
            IE: 'Ireland',
            IL: 'Israel',
            IT: 'Italy',
            CI: 'Ivory Coast',
            JM: 'Jamaica',
            JP: 'Japan',
            JE: 'Jersey',
            JO: 'Jordan',
            KZ: 'Kazakhstan',
            KE: 'Kenya',
            KI: 'Kiribati',
            KW: 'Kuwait',
            KG: 'Kyrgyzstan',
            LA: 'Laos',
            LV: 'Latvia',
            LB: 'Lebanon',
            LS: 'Lesotho',
            LR: 'Liberia',
            LY: 'Libya',
            LI: 'Liechtenstein',
            LT: 'Lithuania',
            LU: 'Luxembourg',
            MK: 'Macedonia',
            MG: 'Madagascar',
            MW: 'Malawi',
            MY: 'Malaysia',
            MV: 'Maldives',
            ML: 'Mali',
            MH: 'Marshall Islands',
            MR: 'Mauritania',
            MU: 'Mauritius',
            MX: 'Mexico',
            MD: 'Moldova',
            MN: 'Mongolia',
            ME: 'Montenegro',
            MS: 'Montserrat',
            MA: 'Morocco',
            MZ: 'Mozambique',
            MM: 'Myanmar',
            NA: 'Namibia',
            NR: 'Nauru',
            NP: 'Nepal',
            NZ: 'New Zealand',
            NI: 'Nicaragua',
            NE: 'Niger',
            NG: 'Nigeria',
            NU: 'Niue',
            NF: 'Norfolk Island',
            KP: 'North Korea',
            NO: 'Norway',
            OM: 'Oman',
            PK: 'Pakistan',
            PW: 'Palau',
            PS: 'Palestine',
            PA: 'Panama',
            PG: 'Papua New Guinea',
            PY: 'Paraguay',
            CN: 'People\'s Republic of China',
            PE: 'Peru',
            PH: 'Philippines',
            PN: 'Pitcairn',
            PL: 'Poland',
            PT: 'Portugal',
            QA: 'Qatar',
            TW: 'Republic of China',
            CG: 'Republic of the Congo',
            RO: 'Romania',
            RU: 'Russia',
            RW: 'Rwanda',
            KN: 'Saint Kitts and Nevis',
            LC: 'Saint Lucia',
            VC: 'Saint Vincent and the Grenadines',
            WS: 'Sāmoa',
            SM: 'San Marino',
            ST: 'São Tomé and Príncipe',
            SA: 'Saudi Arabia',
            SN: 'Senegal',
            RS: 'Serbia',
            SC: 'Seychelles',
            SL: 'Sierra Leone',
            SG: 'Singapore',
            SK: 'Slovakia',
            SI: 'Slovenia',
            SB: 'Solomon Islands',
            SO: 'Somalia',
            ZA: 'South Africa',
            GS: 'South Georgia and South Sandwich Islands',
            KR: 'South Korea',
            SS: 'South Sudan',
            ES: 'Spain',
            SD: 'Sudan',
            SR: 'Suriname',
            SZ: 'Swaziland',
            SE: 'Sweden',
            CH: 'Switzerland',
            SY: 'Syria',
            TJ: 'Tajikistan',
            TZ: 'Tanzania',
            TH: 'Thailand',
            NL: 'The Netherlands',
            TG: 'Togo',
            TK: 'Tokelau',
            TO: 'Tonga',
            TT: 'Trinidad and Tobago',
            TN: 'Tunisia',
            TR: 'Turkey',
            TM: 'Turkmenistan',
            TC: 'Turks and Caicos Islands',
            TV: 'Tuvalu',
            UG: 'Uganda',
            UA: 'Ukraine',
            AE: 'United Arab Emirates',
            GB: 'United Kingdom',
            US: 'United States of America',
            UY: 'Uruguay',
            UZ: 'Uzbekistan',
            VU: 'Vanuatu',
            VA: 'Vatican City',
            VE: 'Venezuela',
            VN: 'Vietnam',
            YE: 'Yemen',
            ZM: 'Zambia',
            ZW: 'Zimbabwe'
        }
    };

    private static ru = {
        UPLOAD_FILE: 'Загрузить файл',
        FILE_FIELD: 'Файл',
        FORM_VALIDATION: {
            MISSING: 'Пропущено',
            REQUIRED: 'обязательно для заполнения',
            FILE_TOO_LARGE: 'Максимальный размер файла не должен быть больше 28 мб.',
            CAPTCHA: 'Капча',
            EMAIL: {
                INCORRECT: 'Введите корректный email адрес'
            },
            FIRSTNAME: {
                INCORRECT: 'Введите корректное имя'
            },
            LASTNAME: {
                INCORRECT: 'Введите корректную фамилию'
            },
            COMPANYNAME: {
                INCORRECT: 'Введите название вашей компании'
            },
            BIRTHDAY: {
                INCORRECT: 'Введите дату вашего рождения'
            },
            SUBSCRIBE: {
                REQUIRED: 'Выберите вариант'
            },
            URL: {
                INCORRECT: 'Введите корректный URL (начиная с http:// или https://)'
            },
            NUMBER: {
                OVER_MAX_VALUE: 'Значение должно быть не более',
                OVER_MIN_VALUE: 'Значение должно быть не менее',
                INVALID_NUMBER: 'Введите корректное число'
            },
            TEL: {
                INVALID_CHARACTERS: 'Введите корректный номер телефона',
                MIN_DIGITS_COUNT: 'Значение поля телефона составляет минимум 10 цифр',
                MAX_LENGTH: 'Значение поля телефона — максимум 20 символов'
            },
            DATE: {
                INCOMPLETE_DATE: 'Дата введена не полностью'
            },
            CHECKBOX: {
                MIN_OPTIONS: 'Выберите хотя бы один вариант',
                OVER_MIN_VALUE: 'Минимальное количество опций',
                OVER_MAX_VALUE: 'Максимальное количество опций',
            },
            RADIO: {
                REQUIRED: 'Выберите один из вариантов'
            },
            FILE: {
                REQUIRED: 'Выберите файл'
            },
            PASSWORD: {
                MISMATCH: 'Пароли не совпадают'
            },
            GDPR_POLICY_CONSENT: 'согласие с политикой конфиденциальности'
        },
        EMAIL_FIELD: {
            LABEL: 'Email',
            PLACEHOLDER: 'Введите ваш email'
        },
        FIRSTNAME_FIELD: {
            LABEL: 'Имя',
            PLACEHOLDER: 'Введите ваше имя'
        },
        LASTNAME_FIELD: {
            LABEL: 'Фамилия',
            PLACEHOLDER: 'Введите вашу фамилию'
        },
        COMPANYNAME_FIELD: {
            LABEL: 'Компания',
            PLACEHOLDER: 'Введите название вашей компании'
        },
        BIRTHDAY_FIELD: {
            LABEL: 'Дата рождения',
            FORMAT: 'dd/MM/yyyy',
            PLACEHOLDER: 'DD/MM/YYYY',
        },
        SIGNATURE_FIELD: {
            LABEL: 'Подпись',
            PLACEHOLDER: 'Распишись здесь',
            CLEAR_BUTTON: 'Очистить'
        },
        SUBSCRIBE_FIELD: {
            LABEL: 'Да, подпишите меня на рассылку.',
        },
        ADDRESS_1_FIELD: {
            LABEL: 'Адрес улицы',
            PLACEHOLDER: 'Номер дома и название улицы'
        },
        ADDRESS_2_FIELD: {
            LABEL: 'Адрес улицы 2'
        },
        CITY_FIELD: {
            LABEL: 'Город'
        },
        STATE_FIELD: {
            LABEL: 'Штат / Провинция / Регион'
        },
        POSTAL_FIELD: {
            LABEL: 'Почтовый индекс',
        },
        COUNTRY_FIELD: {
            LABEL: 'Страна',
        },
        URL_FIELD: {
            LABEL: 'Ссылка',
            DESCRIPTION: 'Введите вашу ссылку',
            PLACEHOLDER: 'Введите ссылку',
        },
        RADIO_FIELD: {
            LABEL: 'Переключатель',
            OPTION: 'Опция'
        },
        TEXT_FIELD: {
            LABEL: 'Короткий ответ',
            PLACEHOLDER: 'Напишите здесь...'
        },
        PASSWORD_FIELD: {
            LABEL: 'Пароль',
            PLACEHOLDER: 'Введите пароль...',
            CONFIRMATION_LABEL: 'Подтвердите пароль',
            CONFIRMATION_PLACEHOLDER: 'Подтвердите пароль...',
            SHOW_PASSWORD: 'Показать пароль',
            HIDE_PASSWORD: 'Скрыть пароль',
            STRENGTH: {
                MIN_LENGTH: 'Используйте минимум 10 символов',
                MIXED_CASE: 'Используйте заглавные и строчные английские буквы',
                HAS_NUMBER: 'Используйте хотя бы одну цифру'
            }
        },
        TEXTAREA_FIELD: {
            LABEL: 'Длинный ответ',
            PLACEHOLDER: 'Напишите здесь...'
        },
        NUMBER_FIELD: {
            LABEL: 'Число',
            PLACEHOLDER: 'Введите число',
        },
        TEL_FIELD: {
            LABEL: 'Телефон',
            PLACEHOLDER: 'Введите ваш номер телефона',
        },
        CHECKBOX_FIELD: {
            LABEL: 'Чекбокс',
            CHOICE: 'Вариант'
        },
        TEXT_WIDGET: {
            THANKFUL_PAGE_HEADER: 'Спасибо!',
            THANKFUL_PAGE_TEXT: 'Ваш ответ успешно отправлен.'
        },
        SUBMIT_WIDGET: {
            LABEL: 'отправить',
            PREVIOUS_LABEL: 'предыдущая',
            NEXT_LABEL: 'следующая'
        },
        SIGN_IN_WIDGET: {
            TEXT: 'Войти'
        },
        SIGN_UP_WIDGET: {
            TEXT: 'Зарегистрироваться'
        },
        FORGOT_PASSWORD_WIDGET: {
            TEXT: 'Забыли свой пароль?'
        },
        DATE_FIELD: {
            LABEL: 'Дата',
            FORMAT: 'dd/MM/yyyy'
        },
        DROPDOWN_FIELD: {
            LABEL: 'Выпадающий список',
            OPTION: 'Опция',
            PLACEHOLDER: 'Выбрать из списка',
        },
        HIDDEN_FIELD: {
            LABEL: 'Скрытая переменная',
            SAVE_TO: 'Сохранить в',
            TYPE_DATE: 'Дата и время',
            TYPE_TEXT: 'Текст',
            TYPE_NUMBER: 'Число',
            TYPE_EMAIL: 'Email',
            VALUE_EQ: 'Значение равно',
            SUBMISSION_DATE: 'Дата и время отправки формы'
        },
        ERRORS: {
            CAPTCHA_UNPREPARED: 'Капча не подготовлена',
            VALIDATION_ERROR: 'Ошибка валидации',
            INTERNAL_SERVER_ERROR: 'Что-то пошло не так...',
            TRU_CAPTCHA_INVALID_CHALLENGE_ID: 'Недопустимый ChallengeId для TruCAPTCHA',
            TRU_CAPTCHA_MISSED_RESPONSE: 'Пропущен ответ TruCAPTCHA',
            TRU_CAPTCHA_INVALID_RESPONSE: 'Недопустимый ответ TruCAPTCHA',
            GOOGLE_RECAPTCHA_NOT_CONFIGURED: 'Google reCAPTCHA не настроена',
            GOOGLE_RECAPTCHA_MISSED_RESPONSE: 'Пропущен ответ Google reCAPTCHA',
            GOOGLE_RECAPTCHA_INVALID_RESPONSE: 'Недопустимый ответ Google reCAPTCHA',
            UNHANDLED_ERROR: 'Что-то пошло не так...',
            FORM_NOT_AVAILABLE: 'Форма недоступна'
        },
        GDPR: {
            I_ACCEPT: 'Я согласен(-на) с ',
            AND: ' и ',
            PRIVACY_POLICY: 'Политикой конфиденциальности',
            AGREEMENT_DEFAULT_VOLUME: 'Я согласен(-на) с Политикой конфиденциальности',
            BY_CLICKING_THE: 'Нажимая кнопку "',
            YOU_GIVE_US_PERMISSION: '", вы даете нам разрешение на отправку вам маркетинговых и других сообщений по электронной почте. Вы можете отказаться в любое время.'
        },
        COUNTRY: {
            AU: 'Австралия',
            AT: 'Австрия',
            AZ: 'Азербайджан',
            AL: 'Албания',
            DZ: 'Алжир',
            AI: 'Ангилья',
            AO: 'Ангола',
            AD: 'Андорра',
            AG: 'Антигуа и Барбуда',
            AR: 'Аргентина',
            AM: 'Армения',
            AF: 'Афганистан',
            BS: 'Багамы',
            BD: 'Бангладеш',
            BB: 'Барбадос',
            BH: 'Бахрейн',
            BY: 'Беларусь',
            BZ: 'Белиз',
            BE: 'Бельгия',
            BJ: 'Бенин',
            BM: 'Бермуды',
            BG: 'Болгария',
            BO: 'Боливия',
            BA: 'Босния и Герцеговина',
            BW: 'Ботсвана',
            BR: 'Бразилия',
            IO: 'Британская Территория в Индийском Океане',
            BN: 'Бруней',
            BF: 'Буркина-Фасо',
            BI: 'Бурунди',
            BT: 'Бутан',
            VU: 'Вануату',
            VA: 'Ватикан',
            GB: 'Великобритания',
            HU: 'Венгрия',
            VE: 'Венесуэла',
            VG: 'Виргинские Острова (Брит.)',
            VN: 'Вьетнам',
            GA: 'Габон',
            HT: 'Гаити',
            GY: 'Гайана',
            GM: 'Гамбия',
            GH: 'Гана',
            GT: 'Гватемала',
            GN: 'Гвинея',
            GW: 'Гвинея-Бисау',
            DE: 'Германия',
            HN: 'Гондурас',
            GD: 'Гренада',
            GL: 'Гренландия',
            GR: 'Греция',
            GE: 'Грузия',
            DK: 'Дания',
            CD: 'Демократическая Республика Конго',
            JE: 'Джерси',
            DM: 'Доминика',
            DO: 'Доминиканская Республика',
            EG: 'Египет',
            ZM: 'Замбия',
            ZW: 'Зимбабве',
            IL: 'Израиль',
            IN: 'Индия',
            ID: 'Индонезия',
            JO: 'Иордания',
            IQ: 'Ирак',
            IR: 'Иран',
            IE: 'Ирландия',
            IS: 'Исландия',
            ES: 'Испания',
            IT: 'Италия',
            YE: 'Йемен',
            CV: 'Кабо-Верде',
            KZ: 'Казахстан',
            KH: 'Камбоджа',
            CM: 'Камерун',
            CA: 'Канада',
            QA: 'Катар',
            KE: 'Кения',
            KG: 'Киргизия',
            KI: 'Кирибати',
            CN: 'Китайская Народная Республика',
            TW: 'Китайская Республика',
            CO: 'Колумбия',
            KM: 'Коморы',
            CG: 'Конго',
            KP: 'Корейская Народно-Демократическая Республика',
            CR: 'Коста-Рика',
            CI: 'Кот-д’Ивуар',
            CU: 'Куба',
            KW: 'Кувейт',
            LA: 'Лаос',
            LV: 'Латвия',
            LS: 'Лесото',
            LR: 'Либерия',
            LB: 'Ливан',
            LY: 'Ливия',
            LT: 'Литва',
            LI: 'Лихтенштейн',
            LU: 'Люксембург',
            MU: 'Маврикий',
            MR: 'Мавритания',
            MG: 'Мадагаскар',
            MK: 'Македония',
            MW: 'Малави',
            MY: 'Малайзия',
            ML: 'Мали',
            MV: 'Мальдивы',
            MA: 'Марокко',
            MH: 'Маршалловы Острова',
            MX: 'Мексика',
            MZ: 'Мозамбик',
            MD: 'Молдова',
            MN: 'Монголия',
            MS: 'Монтсеррат',
            MM: 'Мьянма',
            NA: 'Намибия',
            NR: 'Науру',
            NP: 'Непал',
            NE: 'Нигер',
            NG: 'Нигерия',
            NL: 'Нидерланды',
            NI: 'Никарагуа',
            NU: 'Ниуэ',
            NZ: 'Новая Зеландия',
            NO: 'Норвегия',
            AE: 'Объединённые Арабские Эмираты',
            OM: 'Оман',
            NF: 'Остров Норфолк',
            KY: 'Острова Кайман',
            CK: 'Острова Кука',
            TC: 'Острова Тёркс и Кайкос',
            PK: 'Пакистан',
            PW: 'Палау',
            PS: 'Палестина',
            PA: 'Панама',
            PG: 'Папуа — Новая Гвинея',
            PY: 'Парагвай',
            PE: 'Перу',
            PN: 'Питкэрн',
            PL: 'Польша',
            PT: 'Португалия',
            CY: 'Республика Кипр',
            KR: 'Республика Корея',
            RU: 'Россия',
            RW: 'Руанда',
            RO: 'Румыния',
            SV: 'Сальвадор',
            WS: 'Самоа',
            SM: 'Сан-Марино',
            ST: 'Сан-Томе и Принсипи',
            SA: 'Саудовская Аравия',
            SZ: 'Свазиленд',
            SC: 'Сейшелы',
            SN: 'Сенегал',
            VC: 'Сент-Винсент и Гренадины',
            KN: 'Сент-Китс и Невис',
            LC: 'Сент-Люсия',
            RS: 'Сербия',
            SG: 'Сингапур',
            SY: 'Сирия',
            SK: 'Словакия',
            SI: 'Словения',
            US: 'Соединённые Штаты Америки',
            SB: 'Соломоновы Острова',
            SO: 'Сомали',
            SD: 'Судан',
            SR: 'Суринам',
            SL: 'Сьерра-Леоне',
            TJ: 'Таджикистан',
            TH: 'Таиланд',
            TZ: 'Танзания',
            TG: 'Того',
            TK: 'Токелау',
            TO: 'Тонга',
            TT: 'Тринидад и Тобаго',
            TV: 'Тувалу',
            TN: 'Тунис',
            TM: 'Туркмения',
            TR: 'Турция',
            UG: 'Уганда',
            UZ: 'Узбекистан',
            UA: 'Украина',
            UY: 'Уругвай',
            FO: 'Фарерские Острова',
            FM: 'Федеративные Штаты Микронезии',
            FJ: 'Фиджи',
            PH: 'Филиппины',
            FI: 'Финляндия',
            FK: 'Фолклендские Oстрова',
            FR: 'Франция',
            HR: 'Хорватия',
            CF: 'Центральноафриканская Республика',
            TD: 'Чад',
            ME: 'Черногория',
            CZ: 'Чехия',
            CL: 'Чили',
            CH: 'Швейцария',
            SE: 'Швеция',
            EC: 'Эквадор',
            GQ: 'Экваториальная Гвинея',
            ER: 'Эритрея',
            EE: 'Эстония',
            ET: 'Эфиопия',
            GS: 'Южная Георгия и Южные Сандвичевы Острова',
            ZA: 'Южно-Африканская Республика',
            SS: 'Южный Судан',
            JM: 'Ямайка',
            JP: 'Япония'
        }
    };

    public static get UPLOAD_FILE(): string { return  TranslateUtils.getTranslation('UPLOAD_FILE') as string; }
    public static get FILE_FIELD(): string { return  TranslateUtils.getTranslation('FILE_FIELD') as string; }

    public static get FORM_VALIDATION(): {
        MISSING: string;
        REQUIRED: string;
        FILE_TOO_LARGE: string;
        CAPTCHA: string;
        EMAIL: { INCORRECT: string };
        FIRSTNAME: { INCORRECT: string };
        LASTNAME: { INCORRECT: string };
        COMPANYNAME: { INCORRECT: string };
        BIRTHDAY: { INCORRECT: string };
        SUBSCRIBE: { REQUIRED: string };
        URL: { INCORRECT: string };
        NUMBER: { OVER_MAX_VALUE: string; OVER_MIN_VALUE: string; INVALID_NUMBER: string };
        TEL: { INVALID_CHARACTERS: string; MIN_DIGITS_COUNT: string; MAX_LENGTH: string };
        DATE: { INCOMPLETE_DATE: string };
        CHECKBOX: { MIN_OPTIONS: string; OVER_MIN_VALUE: string; OVER_MAX_VALUE: string };
        RADIO: { REQUIRED: string };
        FILE: { REQUIRED: string };
        PASSWORD: { MISMATCH: string };
        GDPR_POLICY_CONSENT: string;
    } {
        return {
            MISSING: TranslateUtils.getTranslation('FORM_VALIDATION', 'MISSING') as string,
            REQUIRED: TranslateUtils.getTranslation('FORM_VALIDATION', 'REQUIRED') as string,
            FILE_TOO_LARGE: TranslateUtils.getTranslation('FORM_VALIDATION', 'FILE_TOO_LARGE') as string,
            CAPTCHA: TranslateUtils.getTranslation('FORM_VALIDATION', 'CAPTCHA') as string,
            EMAIL: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'EMAIL', 'INCORRECT') as string
            },
            FIRSTNAME: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'FIRSTNAME', 'INCORRECT') as string
            },
            LASTNAME: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'LASTNAME', 'INCORRECT') as string
            },
            COMPANYNAME: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'COMPANYNAME', 'INCORRECT') as string
            },
            BIRTHDAY: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'BIRTHDAY', 'INCORRECT') as string
            },
            SUBSCRIBE: {
                REQUIRED: TranslateUtils.getTranslation('FORM_VALIDATION', 'SUBSCRIBE', 'REQUIRED') as string
            },
            URL: {
                INCORRECT: TranslateUtils.getTranslation('FORM_VALIDATION', 'URL', 'INCORRECT') as string
            },
            NUMBER: {
                OVER_MAX_VALUE: TranslateUtils.getTranslation('FORM_VALIDATION', 'NUMBER', 'OVER_MAX_VALUE') as string,
                OVER_MIN_VALUE: TranslateUtils.getTranslation('FORM_VALIDATION', 'NUMBER', 'OVER_MIN_VALUE') as string,
                INVALID_NUMBER: TranslateUtils.getTranslation('FORM_VALIDATION', 'NUMBER', 'INVALID_NUMBER') as string,
            },
            TEL: {
                INVALID_CHARACTERS: TranslateUtils.getTranslation('FORM_VALIDATION', 'TEL', 'INVALID_CHARACTERS') as string,
                MIN_DIGITS_COUNT: TranslateUtils.getTranslation('FORM_VALIDATION', 'TEL', 'MIN_DIGITS_COUNT') as string,
                MAX_LENGTH: TranslateUtils.getTranslation('FORM_VALIDATION', 'TEL', 'MAX_LENGTH') as string,
            },
            DATE: {
                INCOMPLETE_DATE: TranslateUtils.getTranslation('FORM_VALIDATION', 'DATE', 'INCOMPLETE_DATE') as string
            },
            CHECKBOX: {
                MIN_OPTIONS: TranslateUtils.getTranslation('FORM_VALIDATION', 'CHECKBOX', 'MIN_OPTIONS') as string,
                OVER_MIN_VALUE: TranslateUtils.getTranslation('FORM_VALIDATION', 'CHECKBOX', 'OVER_MIN_VALUE') as string,
                OVER_MAX_VALUE: TranslateUtils.getTranslation('FORM_VALIDATION', 'CHECKBOX', 'OVER_MAX_VALUE') as string,
            },
            RADIO: {
                REQUIRED: TranslateUtils.getTranslation('FORM_VALIDATION', 'RADIO', 'REQUIRED') as string
            },
            FILE: {
                REQUIRED: TranslateUtils.getTranslation('FORM_VALIDATION', 'FILE', 'REQUIRED') as string
            },
            PASSWORD: {
                MISMATCH: TranslateUtils.getTranslation('FORM_VALIDATION', 'PASSWORD', 'MISMATCH') as string
            },
            GDPR_POLICY_CONSENT: TranslateUtils.getTranslation('FORM_VALIDATION', 'GDPR_POLICY_CONSENT') as string,
        };
    }

    public static get HIDDEN_FIELD(): {
        LABEL: string;
        SAVE_TO: string;
        TYPE_DATE: string;
        TYPE_TEXT: string;
        TYPE_NUMBER: string;
        TYPE_EMAIL: string;
        VALUE_EQ: string;
        SUBMISSION_DATE: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('HIDDEN_FIELD', 'LABEL') as string,
            SAVE_TO: TranslateUtils.getTranslation('HIDDEN_FIELD', 'SAVE_TO') as string,
            TYPE_DATE: TranslateUtils.getTranslation('HIDDEN_FIELD', 'TYPE_DATE') as string,
            TYPE_TEXT: TranslateUtils.getTranslation('HIDDEN_FIELD', 'TYPE_TEXT') as string,
            TYPE_NUMBER: TranslateUtils.getTranslation('HIDDEN_FIELD', 'TYPE_NUMBER') as string,
            TYPE_EMAIL: TranslateUtils.getTranslation('HIDDEN_FIELD', 'TYPE_EMAIL') as string,
            VALUE_EQ: TranslateUtils.getTranslation('HIDDEN_FIELD', 'VALUE_EQ') as string,
            SUBMISSION_DATE: TranslateUtils.getTranslation('HIDDEN_FIELD', 'SUBMISSION_DATE') as string
        };
    }

    public static get RADIO_FIELD(): {
        LABEL: string;
        OPTION: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('RADIO_FIELD.LABEL') as string,
            OPTION: TranslateUtils.getTranslation('RADIO_FIELD.OPTION') as string
        };
    }

    public static get TEXT_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('TEXT_FIELD.LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('TEXT_FIELD.PLACEHOLDER') as string
        };
    }

    public static get PASSWORD_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
        CONFIRMATION_LABEL: string;
        CONFIRMATION_PLACEHOLDER: string;
        SHOW_PASSWORD: string;
        HIDE_PASSWORD: string;
        STRENGTH: {
            MIN_LENGTH: string;
            MIXED_CASE: string;
            HAS_NUMBER: string;
        };
    } {
        return {
            LABEL: TranslateUtils.getTranslation('PASSWORD_FIELD.LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('PASSWORD_FIELD.PLACEHOLDER') as string,
            CONFIRMATION_LABEL: TranslateUtils.getTranslation('PASSWORD_FIELD.CONFIRMATION_LABEL') as string,
            CONFIRMATION_PLACEHOLDER: TranslateUtils.getTranslation('PASSWORD_FIELD.CONFIRMATION_PLACEHOLDER') as string,
            SHOW_PASSWORD: TranslateUtils.getTranslation('PASSWORD_FIELD.SHOW_PASSWORD') as string,
            HIDE_PASSWORD: TranslateUtils.getTranslation('PASSWORD_FIELD.HIDE_PASSWORD') as string,
            STRENGTH: {
                MIN_LENGTH: TranslateUtils.getTranslation('PASSWORD_FIELD.STRENGTH.MIN_LENGTH') as string,
                MIXED_CASE: TranslateUtils.getTranslation('PASSWORD_FIELD.STRENGTH.MIXED_CASE') as string,
                HAS_NUMBER: TranslateUtils.getTranslation('PASSWORD_FIELD.STRENGTH.HAS_NUMBER') as string
            }
        };
    }

    public static get TEXTAREA_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('TEXTAREA_FIELD.LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('TEXTAREA_FIELD.PLACEHOLDER') as string
        };
    }

    public static get NUMBER_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('NUMBER_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('NUMBER_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get TEL_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('TEL_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('TEL_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get EMAIL_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('EMAIL_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('EMAIL_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get FIRSTNAME_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('FIRSTNAME_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('FIRSTNAME_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get LASTNAME_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('LASTNAME_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('LASTNAME_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get COMPANYNAME_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('COMPANYNAME_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('COMPANYNAME_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get BIRTHDAY_FIELD(): {
        LABEL: string;
        FORMAT: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('BIRTHDAY_FIELD', 'LABEL') as string,
            FORMAT: TranslateUtils.getTranslation('BIRTHDAY_FIELD', 'FORMAT') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('BIRTHDAY_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get SIGNATURE_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
        CLEAR_BUTTON: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('SIGNATURE_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('SIGNATURE_FIELD', 'PLACEHOLDER') as string,
            CLEAR_BUTTON: TranslateUtils.getTranslation('SIGNATURE_FIELD', 'CLEAR_BUTTON') as string,
        };
    }

    public static get SUBSCRIBE_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('SUBSCRIBE_FIELD', 'LABEL') as string,
        };
    }

    public static get ADDRESS_1_FIELD(): {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('ADDRESS_1_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('ADDRESS_1_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get ADDRESS_2_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('ADDRESS_2_FIELD', 'LABEL') as string,
        };
    }

    public static get CITY_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('CITY_FIELD', 'LABEL') as string,
        };
    }

    public static get STATE_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('STATE_FIELD', 'LABEL') as string,
        };
    }

    public static get POSTAL_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('POSTAL_FIELD', 'LABEL') as string,
        };
    }

    public static get COUNTRY_FIELD(): {
        LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('COUNTRY_FIELD', 'LABEL') as string,
        };
    }

    public static get URL_FIELD() : {
        LABEL: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('URL_FIELD', 'LABEL') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('URL_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get CHECKBOX_FIELD(): {
        LABEL: string;
        CHOICE: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('CHECKBOX_FIELD', 'LABEL') as string,
            CHOICE: TranslateUtils.getTranslation('CHECKBOX_FIELD', 'CHOICE') as string,
        };
    }

    public static get TEXT_WIDGET(): {
        THANKFUL_PAGE_HEADER: string;
        THANKFUL_PAGE_TEXT: string;
    } {
        return {
            THANKFUL_PAGE_HEADER: TranslateUtils.getTranslation('TEXT_WIDGET', 'THANKFUL_PAGE_HEADER') as string,
            THANKFUL_PAGE_TEXT: TranslateUtils.getTranslation('TEXT_WIDGET', 'THANKFUL_PAGE_TEXT') as string
        };
    }

    public static get SUBMIT_WIDGET(): {
        LABEL: string;
        PREVIOUS_LABEL: string;
        NEXT_LABEL: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('SUBMIT_WIDGET', 'LABEL') as string,
            PREVIOUS_LABEL: TranslateUtils.getTranslation('SUBMIT_WIDGET', 'PREVIOUS_LABEL') as string,
            NEXT_LABEL: TranslateUtils.getTranslation('SUBMIT_WIDGET', 'NEXT_LABEL') as string
        };
    }

    public static get SIGN_IN_WIDGET(): {
        TEXT: string;
    } {
        return {
            TEXT: TranslateUtils.getTranslation('SIGN_IN_WIDGET', 'TEXT') as string
        };
    }

    public static get SIGN_UP_WIDGET(): {
        TEXT: string;
    } {
        return {
            TEXT: TranslateUtils.getTranslation('SIGN_UP_WIDGET', 'TEXT') as string
        };
    }

    public static get FORGOT_PASSWORD_WIDGET(): {
        TEXT: string;
    } {
        return {
            TEXT: TranslateUtils.getTranslation('FORGOT_PASSWORD_WIDGET', 'TEXT') as string
        };
    }

    public static get DATE_FIELD(): {
        LABEL: string;
        FORMAT: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('DATE_FIELD.LABEL') as string,
            FORMAT: TranslateUtils.getTranslation('DATE_FIELD.FORMAT') as string
        };
    }

    public static get DROPDOWN_FIELD() : {
        LABEL: string;
        OPTION: string;
        PLACEHOLDER: string;
    } {
        return {
            LABEL: TranslateUtils.getTranslation('DROPDOWN_FIELD.LABEL') as string,
            OPTION: TranslateUtils.getTranslation('DROPDOWN_FIELD.OPTION') as string,
            PLACEHOLDER: TranslateUtils.getTranslation('DROPDOWN_FIELD', 'PLACEHOLDER') as string,
        };
    }

    public static get ERRORS(): {
        CAPTCHA_UNPREPARED: string;
        VALIDATION_ERROR: string;
        INTERNAL_SERVER_ERROR: string;
        TRU_CAPTCHA_INVALID_CHALLENGE_ID: string;
        TRU_CAPTCHA_MISSED_RESPONSE: string;
        TRU_CAPTCHA_INVALID_RESPONSE: string;
        GOOGLE_RECAPTCHA_NOT_CONFIGURED: string;
        GOOGLE_RECAPTCHA_MISSED_RESPONSE: string;
        GOOGLE_RECAPTCHA_INVALID_RESPONSE: string;
        UNHANDLED_ERROR: string;
        FORM_NOT_AVAILABLE: string;
    } {
        return {
            CAPTCHA_UNPREPARED: TranslateUtils.getTranslation('ERRORS', 'CAPTCHA_UNPREPARED') as string,
            VALIDATION_ERROR: TranslateUtils.getTranslation('ERRORS', 'VALIDATION_ERROR') as string,
            INTERNAL_SERVER_ERROR: TranslateUtils.getTranslation('ERRORS', 'INTERNAL_SERVER_ERROR') as string,
            TRU_CAPTCHA_INVALID_CHALLENGE_ID: TranslateUtils.getTranslation('ERRORS', 'TRU_CAPTCHA_INVALID_CHALLENGE_ID') as string,
            TRU_CAPTCHA_MISSED_RESPONSE: TranslateUtils.getTranslation('ERRORS', 'TRU_CAPTCHA_MISSED_RESPONSE') as string,
            TRU_CAPTCHA_INVALID_RESPONSE: TranslateUtils.getTranslation('ERRORS', 'TRU_CAPTCHA_INVALID_RESPONSE') as string,
            GOOGLE_RECAPTCHA_NOT_CONFIGURED: TranslateUtils.getTranslation('ERRORS', 'GOOGLE_RECAPTCHA_NOT_CONFIGURED') as string,
            GOOGLE_RECAPTCHA_MISSED_RESPONSE: TranslateUtils.getTranslation('ERRORS', 'GOOGLE_RECAPTCHA_MISSED_RESPONSE') as string,
            GOOGLE_RECAPTCHA_INVALID_RESPONSE: TranslateUtils.getTranslation('ERRORS', 'GOOGLE_RECAPTCHA_INVALID_RESPONSE') as string,
            UNHANDLED_ERROR: TranslateUtils.getTranslation('ERRORS', 'UNHANDLED_ERROR') as string,
            FORM_NOT_AVAILABLE: TranslateUtils.getTranslation('ERRORS', 'FORM_NOT_AVAILABLE') as string,
        };
    }

    public static get GDPR(): {
        I_ACCEPT: string;
        AND: string;
        PRIVACY_POLICY: string;
        AGREEMENT_DEFAULT_VOLUME: string;
        BY_CLICKING_THE: string;
        YOU_GIVE_US_PERMISSION: string;
    } {
        return {
            I_ACCEPT: TranslateUtils.getTranslation('GDPR', 'I_ACCEPT') as string,
            AND: TranslateUtils.getTranslation('GDPR', 'AND') as string,
            PRIVACY_POLICY: TranslateUtils.getTranslation('GDPR', 'PRIVACY_POLICY') as string,
            AGREEMENT_DEFAULT_VOLUME: TranslateUtils.getTranslation('GDPR', 'AGREEMENT_DEFAULT_VOLUME') as string,
            BY_CLICKING_THE: TranslateUtils.getTranslation('GDPR', 'BY_CLICKING_THE') as string,
            YOU_GIVE_US_PERMISSION: TranslateUtils.getTranslation('GDPR', 'YOU_GIVE_US_PERMISSION') as string,
        };
    }

    public static get COUNTRY(): Record<string, string> {
        const countryData = document.documentElement.lang === 'ru'
            ? TranslateUtils.ru.COUNTRY
            : TranslateUtils.en.COUNTRY;

        return Object.keys(countryData).reduce((acc, key) => {
            acc[key] = countryData[key as keyof typeof countryData];
            return acc;
        }, {} as Record<string, string>);
    }

    public static getTranslation(...keys: string[]): string {
        const obj = document.documentElement.lang === 'ru' ? TranslateUtils.ru : TranslateUtils.en;
        const result = ObjectUtils.getObjValueByStr(obj, keys.join('.'));
        return typeof result === 'string' ? result : '';
    }

    public static prepareKey(key: string): string {
        return key.replaceAll('-', '_').toLocaleUpperCase();
    }
}
